<template>
  <div id="app">
    <app-sidenav></app-sidenav>
    <router-view class="main" v-bind:key="$route.fullPath"></router-view>
    <md-snackbar md-position="top center" ref="snackbar">
      <div class="snackbar">
        <h3>{{ snackbar.title }}</h3>
        <img v-bind:src="snackbar.icon" />
        <p>{{ snackbar.body }}</p>
      </div>
    </md-snackbar>
  </div>
</template>

<script>
import Sidenav from "@/components/Sidenav";
import { messaging } from "./helpers/firebase";

export default {
  name: "app",
  components: {
    appSidenav: Sidenav
  },
  data() {
    return {
      snackbar: {
        title: "",
        body: "",
        icon: ""
      }
    };
  },
  mounted() {
    messaging.onMessage(payload => {
      this.snackbar.title = payload.notification.title;
      this.snackbar.body = payload.notification.body;
      this.snackbar.icon = payload.notification.icon;
      this.$refs.snackbar.open();
    });
  }
};
</script>

<style>
:root {
  --sizebar-size: 280px;
}

html,
body {
  height: 100%;
  overflow: hidden;
}

body {
  font-family: Vibur;
  font-size: 16px;
  display: flex;
}

#app {
  min-height: 100%;
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
}

.main {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.main-content {
  padding: 16px;
  flex: 1;
  overflow: auto;
  background-color: #fff;
}

.main-sidebar.md-sidenav .md-sidenav-content {
  width: var(--sizebar-size);
  display: flex;
  flex-flow: column;
  overflow: hidden;
}

.md-title.main-title {
  flex: 1;
}

@media (min-width: 639px) {
  #app {
    transform: translate3d(0, 0, 0);
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    padding-left: var(--sizebar-size);
  }
  .main-sidebar.md-sidenav.md-left .md-sidenav-content {
    top: 0;
    pointer-events: auto;
    transform: translate3d(0, 0, 0);
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.12);
  }
  .main-sidebar.md-sidenav .md-backdrop {
    opacity: 0;
    pointer-events: none;
  }
  .md-button.nav-trigger {
    display: none;
  }
  .md-toolbar .md-title.main-title {
    margin-left: 16px;
  }
}

.main-sidebar-content {
  overflow: auto;
  flex: 1;
}

h1,
h2,
h3,
h4 {
  font-family: Pacifico;
  font-variant: normal;
}

.material-icons {
  font-variant: normal;
}

#logo {
  height: 40px;
  margin-right: 10px;
}

.md-toolbar .md-title {
  color: white;
  font-size: 1.6em;
}

.snackbar img {
  float: left;
  margin-right: 10px;
  max-width: 64px;
}
</style>
